/**
 * External Dependants
 */
import React from 'react';
import Page from 'page';
import classNames from 'classnames';

/**
 * Inernal Dependants
 */
import Icon from 'components/icon';

const Item = ({ label = '', path = '', selected = false, icon = null, onNavigate, className, children }) => {
	const classes = classNames('sidebar__menu-item', className, { selected: selected });
	return (
		<li className={classes}>
            <a className="sidebar__menu-link"  href={path} onClick={onNavigate}>
				{icon && <Icon className='sidebar__menu-icon' {...icon}/>}
				<span className='sidebar__menu-link-text menu-link-text'>
					{label}
				</span>
			</a>
			{children}
		</li>
	);
};

export default Item;
